import { RecordPropsDefinition } from "vue/types/options";

import IconSpeakerActive from "../../assets/icons/default/Speaker.svg";
import IconSpeakerInactive from "../../assets/icons/transparent/Speaker.svg";
import IconSpeakerBlocked from "../../assets/icons/white/Speaker.svg";
import IconWhiteCheck from "../../assets/icons/white/Check.svg";
import IconWhiteClose from "../../assets/icons/white/Close.svg";

import {
  ChatAudioStatus,
  PropsHasSpeakerIcon,
  PropsIsCorrect,
} from "../../models/chat";

/**
 * Props definition of `PropsHasSpeakerIcon`
 */
export const propsDefHasSpeakerIcon: RecordPropsDefinition<PropsHasSpeakerIcon> = {
  audioStatus: {
    type: String as () => ChatAudioStatus,
    default: "none",
    validator: (val: string) => ["idle", "playing", "none", "blocked"].includes(val),
  },
  iconSpeakerActive: { type: String, default: IconSpeakerActive },
  iconSpeakerInactive: { type: String, default: IconSpeakerInactive },
  iconSpeakerBlocked: { type: String, default: IconSpeakerBlocked },
};

/**
 * Props definition of `PropsIsCorrect`. By default, a message correctness
 * is neutral
 */
export const propsDefIsCorrect: RecordPropsDefinition<PropsIsCorrect> = {
  isCorrect: { type: Boolean, default: undefined },
  iconCorrect: { type: String, default: IconWhiteCheck },
  iconIncorrect: { type: String, default: IconWhiteClose },
};
